export default __webpack_public_path__ + "static/media/hbA1c-icon.ecac3a25.svg";